document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.getElementById('videoOverlay');
    const iframe = document.getElementById('vimeoPlayer');
    const closeBtn = document.getElementById('closeVideo');

    let player;

    document.querySelectorAll('.open-video').forEach(button => {
        button.addEventListener('click', () => {
            const videoId = button.getAttribute('data-vimeo');
            const videoUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=0&title=0&byline=0&portrait=0`;

            iframe.setAttribute('src', videoUrl);

            // Visa overlay med fade
            overlay.classList.remove('hidden');
            setTimeout(() => overlay.classList.add('active'), 10); // För animation

            // Initiera eller uppdatera spelaren
            if (player) {
                player.loadVideo(videoId).then(() => player.play());
            } else {
                player = new Vimeo.Player(iframe);
            }
        });
    });

    closeBtn.addEventListener('click', () => {
        overlay.classList.remove('active');

        setTimeout(() => {
            overlay.classList.add('hidden');
            iframe.setAttribute('src', '');
        }, 400);

        if (player) {
            player.pause();
        }
    });
});

